// extracted by mini-css-extract-plugin
module.exports = {"team-player-list":"team-player-list","team-player-item":"team-player-item","avatar":"avatar","player-info":"player-info","text":"text","sub-text":"sub-text"};